import React from 'react';
import { ResponsiveRadar } from '@nivo/radar';
import { demoData } from './demoData.js';
import style from './radar-chart.module.scss';
import { getTrans } from '../../Utils/translate.js';

const RadarChart = ({ data, title, noData, lang }) => {
  const {
    radarOverall,
    radarSteep,
    radarSpeed,
    radarCorners,
    radarTech,
    radarPerformance
  } = lang;
  data.map((e) => {
    if (e.kpi_name === 'OVERALL') e.kpi_name = getTrans(radarOverall);
    if (e.kpi_name === 'Corners') e.kpi_name = getTrans(radarCorners);
    if (e.kpi_name === 'Steep') e.kpi_name = getTrans(radarSteep);
    if (e.kpi_name === 'Tech') e.kpi_name = getTrans(radarTech);
    if (e.kpi_name === 'Speed') e.kpi_name = getTrans(radarSpeed);
    return e;
  });

  return (
    <div className="appRow" style={{ position: 'relative' }}>
      {title && <h3 className={`h3 ${style.title}`}>{title}</h3>}
      <div
        style={{
          height: 265,
          width: '100%',
          padding: '0 5px'
        }}
        className={`${style.radarChart}${data ? '' : ` ${style.noData}`}`}
      >
        <ResponsiveRadar
          data={data ? data : demoData}
          keys={['kpi_value']}
          indexBy="kpi_name"
          maxValue={100}
          margin={{
            top: 38,
            right: 80,
            bottom: data ? (data.length > 4 ? 10 : 30) : 10,
            left: 80
          }}
          curve="linearClosed"
          borderWidth={1}
          borderColor="#db0a40"
          gridLevels={4}
          gridShape="circular"
          gridLabelOffset={30}
          enableDots={true}
          dotSize={7}
          dotColor="#001830"
          dotBorderWidth={1}
          dotBorderColor="#db0a40"
          enableDotLabel={true}
          dotLabel="value"
          dotLabelYOffset={-10}
          colors={['#ffffff']}
          fillOpacity={0.1}
          blendMode="normal"
          animate={false}
          isInteractive={false}
          theme={{
            textColor: '#fff',
            fontSize: 14,
            grid: {
              line: {
                stroke: '#fff',
                strokeWidth: 1,
                opacity: 0.3
              }
            },
            dot: {
              label: {
                color: 'red'
              }
            }
          }}
        />
        {!data && <div className={style.resultInfo}>{noData}</div>}
      </div>
      <div className={style.radarInfo}>{getTrans(radarPerformance)}</div>
    </div>
  );
};
export { RadarChart };
